import { useCallback, useMemo } from "react";
import { createAxiosApi } from "../Helpers/axiosApiHelper";
import { useUserContext } from "./useUserContext";

export function useImages(config) {
	const user = useUserContext(config);
	const api = useMemo(() => createAxiosApi("", user, config), [user, config]);

	const list = useCallback((recipeId) => {
		return api.get(`Recipes/${recipeId}/Images`).then((response) => response.data.ImageIds || []);
	}, [api]);

	const upload = useCallback((recipeId, files, onUploadProgress) => {
		const formData = new FormData();
		for (const file of files) {
			formData.append("files", file);
		}
		return api.post(`Recipes/${recipeId}/Images`, formData, {
			headers: { "Content-Type": "multipart/form-data" },
			onUploadProgress
		}).then((response) => response.data.ImageIds || []);
	}, [api]);

	const remove = useCallback((recipeId, imageId) => {
		return api.delete(`Recipes/${recipeId}/Images/${imageId}`);
	}, [api]);

	const reorder = useCallback((recipeId, orderedIds) => {
		return api.put(`Recipes/${recipeId}/Images/order`, orderedIds || []);
	}, [api]);

	return useMemo(() => ({ list, upload, remove, reorder }), [list, upload, remove, reorder]);
}
